import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PowerEngageService {
  private static readonly STORAGE_KEY = 'isPowerEngageEnabled';
  private _isEnabled: boolean;

  constructor() {
    this._isEnabled = this.getInitialState();
  }

  public get isEnabled(): boolean {
    return this._isEnabled;
  }

  public setEnabled(enabled: boolean): void {
    localStorage.setItem(PowerEngageService.STORAGE_KEY, enabled.toString());
    this._isEnabled = enabled;
  }

  public clear(): void {
    localStorage.removeItem(PowerEngageService.STORAGE_KEY);
    this._isEnabled = false;
  }

  private getInitialState(): boolean {
    const stored = localStorage.getItem(PowerEngageService.STORAGE_KEY);
    return stored === 'true';
  }
}
